"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const contactFormInputs = [
  {
    name: "type",
    type: "string",
    defaultValue: "CONTACT",
    enum: [
      { label: "Contact", value: "CONTACT" },
      { label: "Trial Request", value: "TRIAL_REQUEST" },
    ],
  },
  {
    name: "title",
    type: "string",
    required: true,
    defaultValue: "How can we help you?",
  },
  {
    name: "description",
    type: "string",
    required: true,
    defaultValue:
      "The Ploom Care Team is here to help. Give us a call or use the below contact form.",
  },
  {
    name: "disclaimer",
    type: "string",
    defaultValue: "* Fields required",
  },
  {
    name: "errorMessage",
    type: "string",
    defaultValue: "Error occured, please try again later",
  },
  {
    name: "hiddenFields",
    type: "list",
    subFields: [
      {
        name: "key",
        type: "string",
        required: true,
      },
      {
        name: "value",
        type: "string",
        required: true,
      },
    ],
  },
  {
    name: "successScreenTitle",
    type: "string",
    defaultValue: "Success screen title",
  },
  {
    name: "successScreenButtonLabel",
    type: "string",
    defaultValue: "Send another message",
  },
  {
    name: "successScreenHref",
    type: "string",
    defaultValue: "/",
  },
  {
    name: "isPrefilled",
    type: "boolean",
    defaultValue: false,
    friendlyName: "Prefill form fields",
  },
  {
    name: "isPrefilledDisabled",
    type: "boolean",
    defaultValue: false,
    friendlyName: "Disable editing of prefill form fields",
  },
  {
    name: "nameFieldName",
    type: "string",
    defaultValue: "nameFieldName",
  },
  {
    name: "surnameFieldName",
    type: "string",
    defaultValue: "surnameFieldName",
  },
  {
    name: "emailFieldName",
    type: "string",
    defaultValue: "emailFieldName",
  },
  {
    name: "confirmEmailFieldName",
    type: "string",
    defaultValue: "confirmEmailFieldName",
  },
  {
    name: "phoneNumberFieldName",
    type: "string",
    defaultValue: "phoneNumberFieldName",
  },
] as const satisfies Inputs;

export const ContactFormComponent: RegisteredComponent = {
  name: "ContactForm",
  component: withValidation(
    contactFormInputs,
    dynamic(() => import("./ContactForm").then((mod) => mod.ContactForm)),
    "ContactForm"
  ),
  canHaveChildren: true,
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "FormTextInput",
        options: {
          id: "name",
          label: "First name",
          placeholder: "",
        },
      },
    },
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "FormTextInput",
        options: {
          id: "surname",
          label: "Second name",
          placeholder: "",
        },
      },
    },
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "FormTextInput",
        options: {
          id: "email",
          label: "Email",
          placeholder: "",
        },
      },
    },
  ],
  childRequirements: {
    message: "You can only put Form components inside this component",
    query: {
      "component.name": {
        $in: [
          "FormTextInput",
          "FormTextArea",
          "FormSelect",
          "FormCheckbox",
          "FormConsentCheckboxList",
          "Telephone",
          "Text",
        ],
      },
    },
  },
  inputs: contactFormInputs,
};
